export enum ScriptType {
  RegistrationChatScript = 1,
  WebsiteChatScript = 2,
  GoogleAnalyticsScript = 3,
  SmartLookScript = 4
}
